import { ajaxController } from './controller/AjaxController'
import type { ClientSyncFailure, SyncRequest, SyncResponse } from '../DTOs/Sync/SyncDtos'

// Note: bounded, because the sync worker cannot try again until this call settles, and a request lost on a
// dying link otherwise stays pending until the app is closed. The server applies each change once by its
// ClientId, so a batch that times out part-way is safe to send again.
const SYNC_TIMEOUT_MS = 90_000
const FAILURES_TIMEOUT_MS = 20_000

class SyncAjax {
  async sync(request: SyncRequest) {
    return ajaxController.post<SyncRequest, SyncResponse>('/Sync', request, { timeoutMs: SYNC_TIMEOUT_MS })
  }

  async recordFailures(failures: ClientSyncFailure[]) {
    return ajaxController.post<ClientSyncFailure[], number>('/Sync/failures', failures, { timeoutMs: FAILURES_TIMEOUT_MS })
  }
}

export const syncAjax = new SyncAjax()
